/*
 * @descripttion: 工具函数
 * @version: 1.0.1
 * @Author: echo
 * @Date: 2021-04-28 02:04:36
 * @LastEditors: echo
 * @LastEditTime: 2022-04-12 01:14:12
 */
import { version, name } from '../../package.json'
/**
 * 当前包名
 */
export const appName = name
/**
 * 当前包版本号
 */
export const appVersion = version
/**
 * 当前环境
 */
export const appEnv = import.meta.env.VITE_ENV
/**
 * 判断当前是否是测试环境
 */
export const isDev = appEnv === 'development'
/**
 * 判断当前是否是正式环境
 */
export const isPro = appEnv === 'production'
/**
 * 判断当前是否是预发布环境
 */
export const isPre = appEnv === 'prerelease'
/**
 * 获取自定义环境变量
 */
export function getEnv(key: keyof ImportMetaEnv) {
  return isDev ? import.meta.env[key] : window.__BD__APP__CONF__[key]
}
/**
 * 拼凑文件下载url
 */
export function genFileDownUrl(path: string) {
  const host = getEnv('VITE_BD_FILE_HOST')
  return host + path
}
